import { object, string } from "yup";
import { JPdateRegex, emailRegex, passwordRules } from "../regex";
import { checkValidEmail } from "./logInSchema";

type CreateAccountFormErrorHeaders = {
    requiredField: string;
    email: string;
    passwordRules: string;
    maxEmailCharacters?: string;
    maxNameCharacters?: string;
    dateOfBirth?: string;
};

export default function getCreateAccountValidationSchema(
    headers: CreateAccountFormErrorHeaders,
    withNames = false,
    country?: string
) {
    const isJP = country === "JP";

    const requirements = {
        email: string()
            .trim()
            .required(headers.requiredField)
            .matches(emailRegex, headers.email)
            .email(headers.email)
            .max(35, headers.maxEmailCharacters)
            .concat(checkValidEmail(headers.email)),
        password: string()
            .required(headers.requiredField)
            .matches(passwordRules, headers.passwordRules),
        phoneticFirstName: string().when([], () =>
            isJP && !withNames
                ? string()
                      .required(headers.requiredField)
                      .nonNullable(headers.requiredField)
                      .max(25, headers.maxNameCharacters)
                : string().notRequired().nullable()
        ),
        phoneticLastName: string().when([], () =>
            isJP && !withNames
                ? string()
                      .required(headers.requiredField)
                      .nonNullable(headers.requiredField)
                      .max(25, headers.maxNameCharacters)
                : string().notRequired().nullable()
        ),
        dateOfBirth: string().when([], () =>
            isJP
                ? string()
                      .matches(JPdateRegex, headers.dateOfBirth)
                      .required(headers.requiredField)
                      .nonNullable(headers.requiredField)
                : string().notRequired().nullable()
        ),
    };

    if (!withNames) {
        requirements["firstName"] = string()
            .max(25, headers.maxNameCharacters)
            .required(headers.requiredField);
        requirements["lastName"] = string()
            .max(25, headers.maxNameCharacters)
            .required(headers.requiredField);
    }

    return object().shape(requirements);
}
